import { arabicRegx, englishRegx, numbersRegx } from '../../config/constants';

const isArabic = (value: string) => {
  return value.match(arabicRegx);
};

const isEnglish = (value: string) => {
  return value.match(englishRegx);
};

const isArabicOrEnglish = (value: string) => {
  return value.match(arabicRegx) || value.match(englishRegx);
};

const isValidName = (value: string) => {
  return nonEmpty(value) && isArabicOrEnglish(value);
};

const isRegularNumber = (value: string) => {
  return nonEmpty(value) && value.match(numbersRegx);
};

const isPhoneNumber = (value: string) => {
  // Remove any non-digit characters from the phone number
  value = value.replace(/\D/g, '');

  // Check if the phone number starts with 0/5
  if (!value.startsWith('0') && !value.startsWith('5')) {
    return false;
  }

  const expectedLength = 10;
  if (
    value.length !== expectedLength && // In case of 05xxxxxxxx
    value.length !== expectedLength - 1 // In case of 5xxxxxxxx
  ) {
    return false;
  }

  // Additional validation rules specific to each country can be added here

  // If all checks pass, the phone number is considered valid
  return nonEmpty(value) && true;
};

const isEmail = (value: string) => {
  return (
    nonEmpty(value) &&
    value.match(/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/)
  );
};

const isURL = (value: string) => {
  return nonEmpty(value) && value.match(/^(http|https):\/\/[^ "]+$/);
};

const isValidID = (value: string) => {
  // length of 9 charachters
  return nonEmpty(value) && value.match(/^[0-9]{9}$/);
};

const isValidTaxID = (value: string) => {
  // length of 9 charachters
  return nonEmpty(value) && value.match(/^[0-9]{9}$/);
};

const isValidBankAccountNumber = (value: string) => {
  // length of 9 charachters
  return isRegularNumber(value);
};

const isValidBankBranchNumber = (value: string) => {
  // length of 3 charachters
  return nonEmpty(value) && value.match(/^[0-9]{3}$/);
};

const isValidBankNumber = (value: string) => {
  // length of 5 to 7 charachters
  return nonEmpty(value) && value.match(/^[0-9]{2}$/);
};

const nonEmpty = (value: string) => {
  return value !== null && value !== undefined && value !== '';
};

export const FormValidators = {
  isPhoneNumber,
  isEmail,
  isURL,
  isArabic,
  isEnglish,
  isValidName,
  isRegularNumber,
  isValidID,
  isValidTaxID,
  isValidBankAccountNumber,
  isValidBankBranchNumber,
  isValidBankNumber,
};
